/** this is used for Black Friday the main purpose of this function for now is
 *  to return a String based on an array of strings.
 *  Future use would be that we send a list of conditions and it can generate
 *  a string of classes
*/

function arrayToString(condition) {
  if (condition) {
    const listOfClasses = [];
    listOfClasses.push(condition ? 'black-friday' : '');
    return listOfClasses.join(' ');
  }
  return '';
}

export default arrayToString;
